import { render, staticRenderFns } from "./edit_share.vue?vue&type=template&id=ed7661d0&scoped=true"
import script from "./edit_share.vue?vue&type=script&lang=js"
export * from "./edit_share.vue?vue&type=script&lang=js"
import style0 from "./edit_share.vue?vue&type=style&index=0&id=ed7661d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7661d0",
  null
  
)

export default component.exports